import { render, staticRenderFns } from "./ParentTask.vue?vue&type=template&id=b3507472&scoped=true&"
import script from "./ParentTask.vue?vue&type=script&lang=js&"
export * from "./ParentTask.vue?vue&type=script&lang=js&"
import style0 from "./ParentTask.vue?vue&type=style&index=0&id=b3507472&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3507472",
  null
  
)

export default component.exports